'use client';
import { Checkbox } from '@curology/ui-components-web/react/Checkbox';
import React from 'react';

import LegalLinks from '@/components/legalLinks';
import { type Brand } from '@/consts/brands';

import { FORM_CONFIG } from '../config';

const TermsAndConditions: React.FC<{
  brand: Brand;
  hasAcceptedTerms: boolean;
  setHasAcceptedTerms: (value: boolean) => void;
  withTosCheckbox?: boolean;
}> = ({ brand, hasAcceptedTerms, setHasAcceptedTerms, withTosCheckbox }) => {
  const labelStartText = withTosCheckbox
    ? FORM_CONFIG.termsAndConditions.labelStartTextWithTosCheckout
    : FORM_CONFIG.termsAndConditions.labelStartTextWithoutTosCheckout;

  return (
    <div>
      <Checkbox
        aria-hidden={!withTosCheckbox}
        aria-label={FORM_CONFIG.termsAndConditions.label}
        checked={hasAcceptedTerms}
        className="cur-pb-2 cur-pt-4 cur-px-2 [&>div>div]:cur-mt-[6px]"
        onChange={() => setHasAcceptedTerms(!hasAcceptedTerms)}
        name="hasAcceptedTerms"
        value="true"
        label={
          <>
            {labelStartText}
            <LegalLinks.TermsOfService brand={brand} />
            {', '}
            <LegalLinks.PrivacyPolicy brand={brand} />
            {' and '}
            <LegalLinks.TelehealthConsent brand={brand} />.
          </>
        }
      />
    </div>
  );
};

export default TermsAndConditions;
